// Dependencies
import { Component } from 'react';

import { connect } from 'react-redux';

import { bindActionCreators, Dispatch } from 'redux';

import {
    SetErrorHandlerAction,
    setErrorHandlerAction,
    SetSystemLoadingAction,
    setSystemLoadingAction,
    ShowMessageAction,
    showMessageAction,
} from 'store/actions/errorsActions';
import { SetLayoutAction, setLayoutAction } from 'store/actions/layoutActions';
import { Layout, OpenModal, PortType, RootState } from 'types';

import { DateTimeFormat } from 'utils/dateTimeFormat';
import { clone } from 'utils/formHandlers';
import { translate } from 'utils/translate';

import { twclsx } from 'utils/twclsx';

interface ChatComponentProps {
    active: boolean;
    setLayoutAction: SetLayoutAction;
    layout: Layout;
    port: PortType;
    dateTimeFormat: DateTimeFormat;
    setErrorHandlerAction: SetErrorHandlerAction;
    showMessageAction: ShowMessageAction;
    setSystemLoadingAction: SetSystemLoadingAction;
    openModelFunction: OpenModal;
}

interface ChatComponentState {
    active: boolean;
    openMenu: boolean;
    loading: boolean;
}

class Chat extends Component<ChatComponentProps, ChatComponentState> {
    constructor(props: ChatComponentProps) {
        super(props);
        this.state = {
            active: false,
            openMenu: props.layout.openMenu,
            loading: false,
        };
    }

    static getDerivedStateFromProps(props: ChatComponentProps, state: ChatComponentState) {
        if (props.active !== state.active) {
            return {
                active: props.active,

                layout: clone(props.layout),
                openMenu: props.layout.openMenu,
            };
        }
        return null;
    }

    shouldComponentUpdate(nextProps: ChatComponentProps, nextState: ChatComponentState): boolean {
        // Render if active changed
        if (nextProps.active !== this.props.active) {
            return true;
        }

        // Render if component state changed
        if (this.state.active) {
            return true;
        }

        // Otherwise don't render
        return false;
    }

    render() {
        return (
            <div
                className={twclsx(
                    !this.state.active && 'hidden',
                    'mt-14',
                    'h-page',
                    'border-r',
                    'border-gray-300',
                    'padding-transition',
                    'fixed',
                    'z-10',
                    'left-0',
                    'right-0',
                    'margin-transition',
                    this.state.openMenu ? 'xl:ml-menu md:ml-14 xl:w-main md:w-fullPage' : 'ml-14 w-fullPage'
                )}
            >
                <div className="flex flex-col h-full">
                    <div className="flex justify-between border-b border-gray-300 py-3 px-2">
                        <div>
                            <div className="text-lg font-bold mb-2">{translate('TransitAnalyst AI trial')}</div>

                            <div>
                                <p>
                                    <strong>{translate('IMPORTANT Note:')}</strong>{' '}
                                    {translate(
                                        'By default, your TA AI trial has access to data from all TA ports that you have access to. If you have access to more than one port you are recommended to issue the following instruction before any other AI prompts:'
                                    )}
                                </p>

                                <p>
                                    <strong>
                                        {translate(
                                            'When answering, use only data from portXXX until I instruct otherwise.'
                                        )}
                                    </strong>
                                </p>

                                <p>
                                    {translate('Where portXXX is the name of one of the ports you can access in TA.')}
                                </p>

                                <p>
                                    <u>
                                        {translate(
                                            'If you do not do this, TA Genie will answer based on the collective data from all ports that you can access.'
                                        )}
                                    </u>
                                </p>

                                <p>
                                    <strong>
                                        {translate(
                                            'Remember that (especially trial) AI results may not be accurate, use results with caution!'
                                        )}
                                    </strong>
                                </p>

                                <p>
                                    {translate(
                                        'Please provide feedback on the usefulness of this AI tab via the help menu.'
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="flex-1 h-full w-full">
                        <iframe
                            src="https://dbc-32584ddc-aac5.cloud.databricks.com/embed/genie/rooms/01f16557ba4a1d768ad6deb7d4a8db2c?o=3723243630113524"
                            className="w-full h-full border-0"
                            title="TransitAnalyst AI trial"
                            allow="clipboard-write"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const chatStateToProps = (state: RootState) => ({
    layout: state.layout.layout,
    port: state.port.port,
    dateTimeFormat: state.port.dateTimeFormat,
    openModelFunction: state.layout.openModelFunction,
});

const chatDispatchToProps = (dispatch: Dispatch) => ({
    setSystemLoadingAction: bindActionCreators(setSystemLoadingAction, dispatch),
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
    showMessageAction: bindActionCreators(showMessageAction, dispatch),
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
});

export default connect(chatStateToProps, chatDispatchToProps)(Chat);
